// extracted by mini-css-extract-plugin
export var container = "submenu-module--container--c94fd";
export var item = "submenu-module--item--aedf2";
export var link = "submenu-module--link--abee7";
export var linksAlignmentRight = "submenu-module--linksAlignmentRight--07dac";